import cookie from 'js-cookie'

const reqThen = config => {
    return config
}
const reqCatch = error => {
    return Promise.reject(error)
}

const resThen = response => {

    if (response.status == 200) {
        var accessToken = response.headers.token; //token
        if (accessToken) {
            localStorage.setItem('token', accessToken);
        }
        return Promise.resolve(response.data);
    }

}
const resCatch = error => {

    // /* 如果是token过期，暂时直接踢到登录页 */
    // if (
    //     typeof error === 'object' &&
    //     error.response.data.code === 400001 &&
    //     error.response.data.message === 'expired token'
    // ) {
    //     router.push('/login')
    // }
    return Promise.reject()
}
export { reqThen, reqCatch, resThen, resCatch }